import styled from 'styled-components';

// TODO: move to config.js
const domain = '/assets/images/';
const images = {
	inFeedLandscape: domain + 'vast_landscape_with_bars.gif',
	inFeedPortrait: domain + 'vast_portrait_with_bar.gif',
	fullscreenPortraitScroller: domain + 'Scroller.gif',
	mpu: domain + 'imagebaner.png',
    leaderboard: domain + 'leaderboard.gif',
    skyscraper: domain + 'skyscraper.png',
    halfpage: domain + 'halfpage.png',
	phoneBanner: domain + 'baner320x50.png',
	safeInFeedLandscape: domain + 'safe_video.gif',
	htmlRichMedia: domain + 'safe_HTML.gif',
	webfullscreen: domain + 'webfullscreen.gif',
	expandableBanner: domain + 'expandable_banner.gif',
	hideBar: domain + 'vast_without_bars.png',
	showBar: domain + 'vast_with_bars.png'
};

export const Preview = styled.div`
	border: 1px solid #b0b2b6;
	box-shadow: 0 2px 2px 0 rgb(0 0 0 / 10%);
	position: fixed;
	top: 50%;
	left: 50%;
	z-index: 2;
	width: 299px;
	height: 517px;
	padding: 0px;
	margin: -250px 0 0 -149px;
	background: url(${({src}) => images[src]}) no-repeat;
	background-color: #F4F7F9;
	background-size: contain;
	background-position: center;
	/*border-radius: 10px;*/
	&:hover {
		cursor: pointer;
	}
`;
